// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import axios from 'axios';
import React from 'react';
import { ACTION_TYPES, API_BASE_URL, NEW_API_BASE_URL, PAGE_TYPES } from '../contants';
import {
  extractProductId,
  generateApiParams,
  getProductJsUrl,
  remodifyResponse,
  replaceCdnHost,
} from '../Helpers/Helpers';

export default function useWidget(
  bid: string,
  bguid: string,
  guid: string,
  pcat: string,
  pid: string,
  setError = null,
  fromRedis: any,
  autoTrigger: string | undefined,
  reTarget: string | undefined,
) {
  const [data, setData] = React.useState(null);
  const [album, setAlbum] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);

  async function fetchAlbum(productIds): Promise<any> {
    setIsLoading(true);
    let endpoint =
      (window?.__APP_API_URL__ ? window?.__APP_API_URL__ : NEW_API_BASE_URL()) +
      `/widget/${guid}?userId=${localStorage.getItem('idukki-widget')} `;

    // removed query params: ?pageLink=${window.location.href}&pageType=homepage
    const visitedProducts = localStorage.getItem('visitedProducts');
    const businessId = localStorage.getItem('businessId');
    let w_pid = pid;
    let w_pcat = pcat;

    if (productIds) {
      w_pid = w_pid ? w_pid + ',' + productIds.join(',') : productIds.join(',');
    }
    if (reTarget && visitedProducts) {
      w_pid = w_pid ? w_pid + ',' + visitedProducts : w_pid;
      endpoint = generateApiParams(endpoint, { atcType: ACTION_TYPES.reTarget });
    }

    if (businessId) {
      endpoint = generateApiParams(endpoint, { bid: businessId });
    }

    if (window?.Shopify?.shop?.includes('myshopify.com')) {
      if (window?.ShopifyAnalytics?.meta?.product?.id) w_pid = window?.ShopifyAnalytics?.meta?.product?.id;
      if (window?.ShopifyAnalytics?.meta?.product?.type) w_pcat = window?.ShopifyAnalytics?.meta?.product?.type;
    }

    if (w_pcat) {
      endpoint = generateApiParams(endpoint, { pageType: PAGE_TYPES.category });
    }

    if (w_pid) {
      endpoint = generateApiParams(endpoint, { pageType: PAGE_TYPES.product });
    }
    const axiosQuery = {
      params: { page: page, pid: w_pid, category: w_pcat },
    };
    /*if (window.location.host.includes('.idukki.io') || window.location.host.includes('localhost')) {
      axiosQuery.headers = { 'Cache-Control': 'max-age=0' };
    }*/
    if (localStorage.getItem(guid)) {
      return await JSON.parse(localStorage.getItem(guid));
    } else
      return await axios
        .get(endpoint, axiosQuery)
        .then(({ data }) => {
          data = replaceCdnHost(data);
          if (fromRedis) {
            localStorage.setItem(guid, JSON.stringify(data));
          }
          if (data.result.data.length > 0 && pid) {
            if (visitedProducts) {
              localStorage.setItem('visitedProducts', visitedProducts + ',' + pid);
            } else {
              localStorage.setItem('visitedProducts', pid);
            }
          }
          localStorage.setItem('businessId', data.result.business_id);
          //for showingonly products on PDP for that SKU.. make it better by curate later @Jangrasourabh
          if (data.status && data.result && data.result.data && pid !== null && pid !== '') {
            const filteredData = {
              ...data,
              result: {
                ...data.result,
                data: data.result.data.map((post) => ({
                  ...post,
                  products: post.products.filter((product) => product.id_from_product === pid),
                })),
              },
            };
            return filteredData as any;
          }
          return data as any;
        })
        .catch((err) => {
          setIsLoading(false);
        });
  }

  const setCustomData = async (productIds) => {
    try {
      const promiseArr = [fetchAlbum(productIds)];
      const [responseAlbum] = await Promise.all(promiseArr);
      if (responseAlbum) {
        let isProducts = false;
        for (const i of responseAlbum.result.data) {
          if (i?.products?.length > 0) {
            isProducts = true;
            break;
          }
        }

        if (
          responseAlbum?.result?.layout?.productsSettings?.ugcOfPlatform &&
          (window?.ShopifyAnalytics?.meta?.product?.id || pid)
        ) {
          const product_id = window?.ShopifyAnalytics?.meta?.product?.id || pid;
          if (responseAlbum.result.layout.productsSettings.ratingPlatform === 'trustoo') {
            const ugcUrl = `https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=${responseAlbum.result.layout.productsSettings.platformKey}&limit=100&page=1&product_id=${product_id}&sort_by=comprehensive-descending&t=1756047799041`;
            try {
              const res = await axios.get(ugcUrl);
              for (const item of res.data.data.list) {
                if (item.resources) {
                  responseAlbum.result.data.push({
                    id: item.id,
                    media_url: item.resources[0].video_player_url || item.resources[0].src,
                    media_type:
                      item.resources.length > 1
                        ? 'CAROUSEL_ALBUM'
                        : item.resources[0].video_player_url
                        ? 'VIDEO'
                        : 'IMAGE',
                    thumbnail_url: item.resources[0].thumb_src,
                    thumbnail: item.resources[0].thumb_src,
                    mediaUrl: item.resources[0].src,
                    caption: item.content,
                    mediaType:
                      item.resources.length > 1
                        ? 'CAROUSEL_ALBUM'
                        : item.resources[0].video_player_url
                        ? 'VIDEO'
                        : 'IMAGE',
                    likes: 0,
                    comment: 0,
                    views: 0,
                    username: item.author,
                    profilePic: '0',
                    children: {
                      data: item.resources.map((res) => ({
                        media_url: res.video_player_url || res.src,
                        media_type: res.video_player_url ? 'VIDEO' : 'IMAGE',
                      })),
                    },
                  });
                }
              }
            } catch (error) {
              console.error('Error fetching UGC data:', error);
            }
          } else if (responseAlbum.result.layout.productsSettings.ratingPlatform === 'bazaarvoice') {
            let ugcUrl = '';

            if (
              window.location.hostname === 'leroymerlin.co.za' ||
              window.location.hostname === 'leroymerlin-stg.vaimo-sa-cloud.co.za'
            ) {
              ugcUrl = `https://apps.bazaarvoice.com/bfd/v1/clients/leroymerlin-za/api-products/cv2/resources/data/reviews.json?resource=reviews&action=PHOTOS_TYPE&filter=productid:eq:${product_id}&filter=contentlocale:eq:en*,es*,it*,pt*,ro*,ru*,uk*,fr*,en_ZA,en_ZA&filter=isratingsonly:eq:false&filter=HasMedia:eq:true&filter_reviews=contentlocale:eq:en*,es*,it*,pt*,ro*,ru*,uk*,fr*,en_ZA,en_ZA&include=authors,products,comments&filteredstats=reviews&Stats=Reviews&limit=100&offset=0&limit_comments=3&sort=helpfulness:desc,totalpositivefeedbackcount:desc&Offset=0&apiversion=5.5&displaycode=17990-en_za`;
            }
            if (ugcUrl) {
              try {
                const res = await axios.get(ugcUrl, {
                  headers: {
                    Accept: '*/*',
                    'Accept-Language': 'en-GB,en;q=0.9,en-US;q=0.8',
                    'Bv-Bfd-Token': '17990,main_site,en_ZA',
                  },
                });
                for (const item of res.data.response.Results) {
                  if (Number(responseAlbum.result.layout.productsSettings.ratingAboveStar) <= item.Rating) {
                    responseAlbum.result.data.push({
                      id: item.Id,
                      media_url: item.Photos[0].Sizes.normal.Url,
                      media_type: 'IMAGE',
                      thumbnail_url: item.Photos[0].Sizes.thumbnail.Url,
                      thumbnail: item.Photos[0].Sizes.thumbnail.Url,
                      mediaUrl: item.Photos[0].Sizes.normal.Url,
                      caption: item.ReviewText,
                      mediaType: 'IMAGE',
                      username: item.UserNickname,
                      likes: 0,
                      comment: 0,
                      views: 0,
                    });
                  }
                }
              } catch (error) {
                console.error('Error  fetching UGC data:', error);
              }
            }
          }
        }

        if (isProducts && responseAlbum?.result?.layout?.productsSettings?.showProductRating) {
          if (responseAlbum.result.layout.productsSettings.ratingPlatform === 'trustoo') {
            if (responseAlbum.result.data.length > 0) {
              await Promise.all(
                responseAlbum.result.data.map(async (data: any) => {
                  if (data?.products?.length > 0) {
                    const updatedProducts = await Promise.all(
                      data.products.map(async (productData: any) => {
                        try {
                          if (productData.id_from_product) {
                            const res = await axios.get(
                              `https://api.trustoo.io/api/v1/reviews/get_shop_install_status?shop_id=${responseAlbum.result.layout.productsSettings.platformKey}&product_id=${productData.id_from_product}`,
                            );
                            return {
                              ...productData,
                              productReview: {
                                totalReview: res?.data?.data?.rating?.total_reviews || 0,
                                rating: parseFloat(res?.data?.data?.rating?.rating || 0),
                              },
                            };
                          } else return productData;
                        } catch (error) {
                          console.error('Error fetching product data:', productData.product_url);
                          return productData; // or handle error as needed
                        }
                      }),
                    );
                    data.products = updatedProducts;
                  }
                  return data;
                }),
              );
            }
          } else if (responseAlbum.result.layout.productsSettings.ratingPlatform === 'bazaarvoice') {
            if (responseAlbum.result.data.length > 0) {
              const allProductIds: string[] = [];

              responseAlbum.result.data.forEach((data: any) => {
                data.products?.forEach((product: any) => {
                  if (product.id_from_product) {
                    allProductIds.push(product.id_from_product);
                  }
                });
              });

              const uniqueProductIds = [...new Set(allProductIds)];

              const productReviewsMap = {};
              if (uniqueProductIds.length > 0) {
                const reviewUrl =
                  `https://apps.bazaarvoice.com/api/data/statistics.json` +
                  `?apiversion=5.4` +
                  `&passkey=${responseAlbum.result.layout.productsSettings.platformKey}` +
                  `&stats=Reviews` +
                  `&filter=ContentLocale:en_ZA,en*,es*,it*,pt*,ro*,ru*,uk*,fr*` +
                  `&filter=ProductId:${uniqueProductIds.join(',')}`;

                try {
                  const reviewRes = await axios.get(reviewUrl);
                  const results = reviewRes?.data?.Results || [];

                  results.forEach((item: any) => {
                    const stats = item?.ProductStatistics;
                    if (stats?.ProductId) {
                      productReviewsMap[stats.ProductId] = stats;
                    }
                  });
                } catch (error) {
                  console.error('Error fetching product reviews:', error);
                }
              }

              responseAlbum.result.data.map((data: any) => {
                if (data?.products?.length > 0) {
                  data.products = data.products.map((product: any) => {
                    const productId = product.id_from_product;
                    const productReview = productId ? productReviewsMap[productId] || null : null;
                    return {
                      ...product,
                      productReview: {
                        totalReview: productReview?.ReviewStatistics?.TotalReviewCount || 0,
                        rating: productReview?.ReviewStatistics?.AverageOverallRating || 0,
                      },
                    };
                  });
                }
                return data;
              });
            }
          }
        }

        if (isProducts && window?.location?.host?.includes('biba.in')) {
          if (responseAlbum.result.data.length > 0) {
            await Promise.all(
              responseAlbum.result.data.map(async (data: any) => {
                if (data?.products?.length > 0) {
                  const updatedProducts = await Promise.all(
                    data.products.map(async (productData: any) => {
                      try {
                        if (productData.product_url) {
                          const res = await axios.get(
                            `${
                              window.location.origin
                            }/on/demandware.store/Sites-Biba-Site/en_IN/Product-Variation?pid=${extractProductId(
                              productData.product_url,
                            )}`,
                          );
                          return { additionalData: res.data, ...productData };
                        } else return productData;
                      } catch (error) {
                        console.error('Error fetching product data:', productData.product_url);
                        return productData; // or handle error as needed
                      }
                    }),
                  );
                  data.products = updatedProducts;
                }
                return data;
              }),
            );
            setIsLoading(false);
            setData(JSON.parse(JSON.stringify(responseAlbum)));
            setAlbum(responseAlbum.result);
            setTotalPages(responseAlbum.totalPage);
          } else {
            setIsLoading(false);
          }
        } else if (isProducts && window?.Shopify) {
          if (responseAlbum.result.data.length > 0) {
            const cleanedPosts = await Promise.all(
              responseAlbum.result.data.map(async (post: any) => {
                if (!post?.products?.length) return post; // no products → keep as is

                const updatedProducts = await Promise.all(
                  post.products.map(async (productData: any) => {
                    try {
                      if (productData.product_url) {
                        const res = await axios.get(getProductJsUrl(productData.product_url));
                        return { coords: productData.coords, ...res.data };
                      }
                      return productData;
                    } catch (error) {
                      console.error('404 product:', productData.product_url);
                      return null; // mark as failed
                    }
                  }),
                );

                // Remove failed products
                const filteredProducts = updatedProducts.filter((p) => p !== null);

                // If ALL products failed → remove entire post
                if (filteredProducts.length === 0) {
                  return null;
                }

                // Otherwise keep post with cleaned product list
                return { ...post, products: filteredProducts };
              }),
            );

            // Remove null posts
            responseAlbum.result.data = cleanedPosts.filter((p) => p !== null);

            setIsLoading(false);
            setData(JSON.parse(JSON.stringify(responseAlbum)));
            setAlbum(responseAlbum.result);
            setTotalPages(responseAlbum.totalPage);
          } else {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
          const modifiedResponse = remodifyResponse(JSON.parse(JSON.stringify(responseAlbum)));
          setData(JSON.parse(JSON.stringify(modifiedResponse)));
          setAlbum(modifiedResponse.result);
          setTotalPages(modifiedResponse?.totalPage);
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (setError) setError(error + '');
    }
  };

  React.useEffect(() => {
    if (autoTrigger != 'false') {
      setCustomData();
    }
  }, [page]);

  return { isLoading, data, album, page, setPage, totalPages, setCustomData };
}
